import {Component, ApplicationRef} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {RoutesService} from './services/routes';
import {UtilsService} from './services/utils';
import { PlatformService } from './services/platform.service';
declare let window: any;

const MAX_XS_WIDTH = 767;

@Component({
    selector: 'app',
    template: `
      <router-outlet></router-outlet>
      `,
})
export class AppComponent {
  subscriptions:any[] = [];

  constructor(
    private router:Router,
    private routes:RoutesService,
    private utils:UtilsService,
    private appref:ApplicationRef,
    private platformService: PlatformService
  ) {
    window.app = this;
    let isFirst = true;
    this.subscriptions.push(this.router.events.subscribe(event => {
      if (this.platformService.isBrowser && event instanceof NavigationEnd && window.innerWidth > MAX_XS_WIDTH) {
        if (!isFirst) {
          window.scrollTo(0, 0);
        }
        isFirst = false;
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngAfterViewInit() {
    if (window.onLucyBotReady) window.onLucyBotReady()
    window.lucyBotReady = true;
    var self = this;
    if (this.platformService.isBrowser) {
      window.jQuery('nav.navbar a').click(function() {
        let elem = window.jQuery(this);
        let url = elem.attr('href');
        if (url !== undefined && url.indexOf('http') !== 0) {
          if (url.indexOf(window.config.basePath) === 0) {
            url = url.substring(window.config.basePath.length, url.length);
          }
          if (url) {
            self.routes.navigate(self.routes.getPathParts(url), false, {queryParams: {}});
            return false;
          }
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts